import React, { useState } from "react";
import { Row, Col, Form } from "react-bootstrap";
import DashHeader from "./DashHeader";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { useFormik } from "formik";
import { useSelector } from "react-redux";
import { LinkContainer } from "react-router-bootstrap";

function Popi() {
  const [formStep, setFormStep] = useState(1);

  const { userInfo } = useSelector((state) => state.userLogin);

  const smeDetails = useSelector((state) => state.userSMEDetails);
  const { sme } = smeDetails;


  function calculateScore(){
    let score = 0
    if (formik.values.infoOfficer === "Yes" ){
      score = score + 1
    }
    if (formik.values.officerTraining === "Yes" ){
      score = score + 1
    }
    if (formik.values.dataPrivacyPolicy === "Yes"){
      score = score + 1
    }
    if (formik.values.paiaCopy === "Yes"){
      score = score + 1
    }
    if (formik.values.websitePp === "Yes"){
      score = score + 1
    }
    if (formik.values.websiteTos === "Yes"){
      score = score + 1
    }
    if (formik.values.paiaManual === "Yes"){
      score = score + 1
    }
    if (formik.values.employeesConsent === "Yes"){
      score = score + 1
    }
    if (formik.values.employeesTraining === "Yes"){
      score = score + 1
    }

    return score
  }

  function calculateAverage(score){
    let total = 5
    if (formik.values.employees === "Yes"){
      total = total + 2
    }
    if (formik.values.website === "Yes"){
      total = total + 2
    }
    const average = Math.round((score/total) * 100)
    console.log('average', average)
    return average

  }

  function updateScore(average){
    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${userInfo?.token}`,
      },
    };

    /* Update Popi Date */
    axios.put(
      "/api/users/popi-compliance-score-update/",
      {
        score: average,
      },
      config
    );
  }

  function generateDoc(allValues){
    const api_secret_key = "TDNMSwa7U1p56gg6gEnH";
    const pdfMonkeyConfig = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${api_secret_key}`,
      },
    };

    axios
        .post(
          "https://api.pdfmonkey.io/api/v1/documents/",
          {
            document: {
              document_template_id: "8F2195B3-0D88-4F5D-9ED0-8EB32145AFA8",
              payload: allValues,
              status: "pending",
            },
          },
          pdfMonkeyConfig
        )
        .then(function (response) {
          console.log("Response Received");
        })
        .catch(function (error) {
          console.log("Error Occured");
        });
  }

  const formik = useFormik({
    initialValues: {
      formType: "popi_health",
      infoOfficer: "",
      officerName: "",
      officerEmail: "",
      officerPhone: "",
      deputyOfficer: "",
      deputyOfficerName: "",
      deputyOfficerEmail: "",
      deputyOfficerPhone: "",
      dataPrivacyPolicy: "",
      website: "",
      websiteTos: "",
      websitePp: "",
      paiaCopy: "",
      paiaCopyLanguage: [],
      paiaManual: "",
      employees: "",
      employeesTraining: "",
      officerTraining: "",
      employeesConsent: "",
    },
    onSubmit: (values) => {
      
      const allValues = values;

      allValues["userId"] = userInfo.id;
      allValues["company_id"] = userInfo.email;
      allValues["doctype_id"] = "LACOONA - POPI CHECK";
      allValues["company_name"] = sme.name;
      allValues["name"] = userInfo.name;

      const score = calculateScore(values)
      const average = calculateAverage(score)

      updateScore(average)

      generateDoc(allValues)

      setFormStep((formStep) => formStep + 1);
      
    }
  });

  function setNextFormStep() {
    setFormStep((formStep) => formStep + 1);
  }

  function setPreviousFormStep() {
    setFormStep((formStep) => formStep - 1);
  }



  /* Multi-Select Functions and Variables */
  return (
    <Col className="dashboard-scrollable-container" lg={9}>
      <Helmet>
        <title>POPIA Compliance Assessment</title>
        <meta
          name="description"
          content="Lacoona Legal helps you ensure POPI compliance ."
        />
        <link rel="canonical" href="/dashboard/popi" />
      </Helmet>
      <DashHeader pageTitle={"POPI Compliance Guidance"} />
      <Row className="dashboard-content-container">
        <Row className="find-lawyer-hero px-5">
          <Col lg={8} className="">
            <Row>
              <h1 className="serious-font">POPIA Health Check</h1>
            </Row>
            <Row>
              <p>
                Complete the form to get a POPIA health assessment mailed to
                your inbox.
              </p>
            </Row>
          </Col>
        </Row>

        <Row className="health-check-form-categories">
          <Col
            onClick={() => setFormStep(1)}
            className={formStep === 1 ? "active-tab" : "tab"}
          >
            <div>Information Officer and Employees</div>
          </Col>
          <Col
            onClick={() => setFormStep(2)}
            className={formStep === 2 ? "active-tab" : "tab"}
          >
            <div>Policies</div>
          </Col>
          
        </Row>
        <Row className="find-a-lawyer-form-container">
          {formStep === 1 && (
            <Col className="form-step" lg={8}>
              <Row>
                <h4 className="form-step-heading">
                  Information Officer Overview
                </h4>
              </Row>
              <Form>
                <div className="find-a-lawyer-form-question">
                  <p className="col-5 mx-3">
                    Do you have a registered Information Officer for your
                    company?
                  </p>
                  <Form.Select
                    required
                    onChange={formik.handleChange}
                    name="infoOfficer"
                    aria-label="Default select example"
                    className="mb-3"
                    defaultValue={"DEFAULT"}
                  >
                    <option value="DEFAULT" disabled>
                      Select...
                    </option>

                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </Form.Select>
                </div>

                {formik.values.infoOfficer === "Yes" && (
                  <div className="info-officer-questions">
                    <div className="find-a-lawyer-form-question">
                      <p className="col-5 mx-3">
                        What is the name of your information officer?
                      </p>
                      <Form.Control
                        type="input"
                        className="mb-3"
                        onChange={formik.handleChange}
                        placeholder="Full Name"
                        name="officerName"
                        value={formik.values.officerName}
                      />
                    </div>
                    <div className="find-a-lawyer-form-question">
                      <p className="col-5 mx-3">
                        What is your information officer's email address?
                      </p>
                      <Form.Control
                        type="input"
                        className="mb-3"
                        onChange={formik.handleChange}
                        placeholder="Email Address"
                        name="officerEmail"
                        value={formik.values.officerEmail}
                      />
                    </div>
                    <div className="find-a-lawyer-form-question">
                      <p className="col-5 mx-3">
                        What is your information officer's phone number?
                      </p>
                      <Form.Control
                        type="input"
                        className="mb-3"
                        onChange={formik.handleChange}
                        placeholder="Phone Number"
                        name="officerPhone"
                        value={formik.values.officerPhone}
                      />
                    </div>
                  </div>
                )}
                {formik.values.infoOfficer === "No" && (
                  <div className="popi-action">
                    <p>
                      Your company does not have a registered Information
                      Officer which is necessary for basic legal compliance.
                      Follow the steps to become compliant.{" "}
                    </p>
                    <p>
                      1. Appoint and register a person in your company as your
                      Information Officer.
                    </p>
                    <p>
                      2. Follow the link and prompts to register your
                      Information Officer on the{" "}
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://inforegulator.org.za/"
                      >
                        {" "}
                        Information Regulator Portal
                      </a>
                      .
                    </p>
                    <p>3. Come back to your POPI Assessment to continue.</p>
                  </div>
                )}

                <div className="find-a-lawyer-form-question">
                  <p className="col-5 mx-3">
                    Do you have a registered deputy Information Officer for your
                    company?
                  </p>
                  <Form.Select
                    onChange={formik.handleChange}
                    name="deputyOfficer"
                    aria-label="Default select example"
                    className="mb-3"
                    defaultValue={"DEFAULT"}
                  >
                    <option value="DEFAULT" disabled>
                      Select...
                    </option>

                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </Form.Select>
                </div>

                {formik.values.deputyOfficer === "Yes" && (
                  <div className="info-officer-questions">
                    <div className="find-a-lawyer-form-question">
                      <p className="col-5 mx-3">
                        What is the name of your deputy information officer?
                      </p>
                      <Form.Control
                        type="input"
                        className="mb-3"
                        onChange={formik.handleChange}
                        placeholder="Full Name"
                        name="deputyOfficerName"
                        value={formik.values.deputyOfficerName}
                      />
                    </div>
                    <div className="find-a-lawyer-form-question">
                      <p className="col-5">
                        What is your deputy information officer's email address?
                      </p>
                      <Form.Control
                        type="input"
                        className="mb-3 mx-3"
                        onChange={formik.handleChange}
                        placeholder="Email Address"
                        name="deputyOfficerEmail"
                        value={formik.values.deputyOfficerEmail}
                      />
                    </div>
                    <div className="find-a-lawyer-form-question">
                      <p className="col-5 mx-3">
                        What is your deputy information officer's phone number?
                      </p>
                      <Form.Control
                        type="input"
                        className="mb-3"
                        onChange={formik.handleChange}
                        placeholder="Phone Number"
                        name="deputyOfficerPhone"
                        value={formik.values.deputyOfficerPhone}
                      />
                    </div>
                  </div>
                )}

                {formik.values.deputyOfficer === "Yes" ? (
                  <div className="find-a-lawyer-form-question">
                    <p className="col-5 mx-3">
                      Has your Information Officers received training on their
                      roles and responsibilities?
                    </p>
                    <Form.Select
                      onChange={formik.handleChange}
                      name="officerTraining"
                      aria-label="Default select example"
                      className="mb-3"
                      defaultValue={"DEFAULT"}
                    >
                      <option value="DEFAULT" disabled>
                        Select...
                      </option>

                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Form.Select>
                  </div>
                ) : (
                  <div className="find-a-lawyer-form-question">
                    <p className="col-5 mx-3">
                      Has your Information Officer received training on their
                      roles and responsibilities?
                    </p>
                    <Form.Select
                      onChange={formik.handleChange}
                      name="officerTraining"
                      aria-label="Default select example"
                      className="mb-3"
                      defaultValue={"DEFAULT"}
                    >
                      <option value="DEFAULT" disabled>
                        Select...
                      </option>

                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Form.Select>
                  </div>
                )}

                {formik.values.officerTraining === "No" && (
                  <div className="popi-action">
                    <p>
                      1. It is possible to follow the link and use the
                      government's free learning and training courses on
                      cybersecurity{" "}
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://edu.globalcyberalliance.org/bundles/small-business?__hstc=11560482.fb2343774b9c95174d44ec52fb5be4ea.1673622199044.1673622199044.1675249884585.2&__hssc=11560482.2.1675249884585&__hsfp=3221652602"
                      >
                        here
                      </a>
                      , or prepare your own training.{" "}
                    </p>
                    <p>
                      2. Complete cybersecurity training with your Information
                      Officer. You must include the roles and responsibilities
                      of the Information Officer which is available in your PAIA
                      Manual.
                    </p>
                    <p>3. Come back to the POPI Assessment to continue.</p>{" "}
                  </div>
                )}

                {/* Employee Section */}

                <div className="find-a-lawyer-form-question">
                  <p className="col-5 mx-3">Do you have any employees?</p>
                  <Form.Select
                    required
                    onChange={formik.handleChange}
                    name="employees"
                    aria-label="Default select example"
                    className="mb-3"
                    defaultValue={"DEFAULT"}
                  >
                    <option value="DEFAULT" disabled>
                      Select...
                    </option>

                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </Form.Select>
                </div>

                {formik.values.employees === "Yes" && (
                  <div className="popi-employee-questions">
                    <div className="find-a-lawyer-form-question">
                      <p className="col-5 mx-3">
                        Have your employees completed training on security and
                        privacy in your company?
                      </p>
                      <Form.Select
                        required
                        onChange={formik.handleChange}
                        name="employeesTraining"
                        aria-label="Default select example"
                        className="mb-3"
                        defaultValue={"DEFAULT"}
                      >
                        <option value="DEFAULT" disabled>
                          Select...
                        </option>

                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </Form.Select>
                    </div>

                    {formik.values.employeesTraining === "No" && (
                      <div className="popi-action">
                        <p>
                          1. It is possible to follow the link and use the
                          government's free learning and training courses on
                          cybersecurity{" "}
                          <a
                            target="_blank"
                            rel="noreferrer"
                            href="https://edu.globalcyberalliance.org/bundles/small-business?__hstc=11560482.fb2343774b9c95174d44ec52fb5be4ea.1673622199044.1673622199044.1675249884585.2&__hssc=11560482.2.1675249884585&__hsfp=3221652602"
                          >
                            here
                          </a>
                          , or prepare your own training.{" "}
                        </p>
                        <p>
                          2. Complete cybersecurity training with all your
                          employees.
                        </p>
                        <p>3. Come back to the POPI Assessment to continue.</p>{" "}
                      </div>
                    )}

                    <div className="find-a-lawyer-form-question">
                      <p className="col-5 mx-3">
                        Have you included a consent clause in all your employee
                        contracts where they consent to you collecting and using
                        personal information?
                      </p>
                      <Form.Select
                        required
                        onChange={formik.handleChange}
                        name="employeesConsent"
                        aria-label="Default select example"
                        className="mb-3"
                        defaultValue={"DEFAULT"}
                      >
                        <option value="DEFAULT" disabled>
                          Select...
                        </option>

                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </Form.Select>
                    </div>

                    {formik.values.employeesConsent === "No" && (
                      <div className="popi-action">
                        <p>
                          1. Follow the{" "}
                          <a
                            target="_blank"
                            rel="noreferrer"
                            href="https://www.lacoona.legal/dashboard/legal-products/intro/2/POPI%20Employee's%20Consent"
                          >
                            link
                          </a>{" "}
                          to complete an Employee Consent Form for each
                          employee.
                        </p>
                        <p>
                          2. Get employees to sign the Consent Form AFTER
                          explaining it to them.{" "}
                        </p>
                        <p>
                          3. Attach the signed Consent Form to each employee's
                          contract.
                        </p>
                        <p>4. Come back to the POPI Assessment to continue.</p>
                      </div>
                    )}
                  </div>
                )}
              </Form>
              <Row>
                <Col>
                  <LinkContainer to={"/dashboard/legal-checks"}>
                    <button className="lcn-button-orange py-2 px-4">
                      Back
                    </button>
                  </LinkContainer>
                </Col>

                <Col className="form-step-next-button-container">
                  <button
                    className="lcn-button-orange py-2 px-4"
                    onClick={setNextFormStep}
                  >
                    Next
                  </button>
                </Col>
              </Row>
            </Col>
          )}

          {formStep === 2 && (
            <Col className="form-step" lg={8}>
              <Row>
                <h4 className="form-step-heading">Policy Information</h4>
              </Row>
              <Form>
                <div className="find-a-lawyer-form-question">
                  <p className="col-5 mx-3">
                    Do you have a data privacy policy?
                  </p>
                  <Form.Select
                    onChange={formik.handleChange}
                    name="dataPrivacyPolicy"
                    aria-label="Default select example"
                    className="mb-3"
                    defaultValue={"DEFAULT"}
                  >
                    <option value="DEFAULT" disabled>
                      Select...
                    </option>

                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </Form.Select>
                </div>

                {formik.values.dataPrivacyPolicy === "No" && (
                  <div className="popi-action">
                    <p>
                      1. Follow the{" "}
                      <a href="https://www.lacoona.legal/dashboard/legal-products/intro/5/POPI%20Data%20Privacy%20Policy">
                        link
                      </a>{" "}
                      to complete a privacy policy with your company details.
                    </p>
                    <p>2. The completed document will be sent to your email.</p>
                    <p>3. Come back to your POPI Assessment to continue.</p>
                  </div>
                )}

                <div className="find-a-lawyer-form-question">
                  <p className="col-5 mx-3">Do you have a website?</p>
                  <Form.Select
                    required
                    onChange={formik.handleChange}
                    name="website"
                    aria-label="Default select example"
                    className="mb-3"
                    defaultValue={"DEFAULT"}
                  >
                    <option value="DEFAULT" disabled>
                      Select...
                    </option>

                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </Form.Select>
                </div>

                {formik.values.website === "Yes" ? (
                  <div className="website-questions">
                    <div className="find-a-lawyer-form-question">
                      <p className="col-5 mx-3">
                        Do you have a website Terms of Service?
                      </p>
                      <Form.Select
                        onChange={formik.handleChange}
                        name="websiteTos"
                        aria-label="Default select example"
                        className="mb-3"
                        defaultValue={"DEFAULT"}
                      >
                        <option value="DEFAULT" disabled>
                          Select...
                        </option>

                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </Form.Select>
                    </div>
                    {formik.values.websiteTos === "No" && (
                      <div className="popi-action">
                        <p>
                          1. Follow the{" "}
                          <a href="https://www.lacoona.legal/dashboard/legal-products/intro/12/Website%20Terms%20of%20Service">
                            link
                          </a>{" "}
                          to complete a website terms of service with your
                          company details.
                        </p>
                        <p>
                          2. The completed document will be sent to your email.
                        </p>
                        <p>3. Come back to your POPI Assessment to continue.</p>
                      </div>
                    )}

                    <div className="find-a-lawyer-form-question">
                      <p className="col-5 mx-3">
                        Do you have a website Privacy Policy?
                      </p>
                      <Form.Select
                        onChange={formik.handleChange}
                        name="websitePp"
                        aria-label="Default select example"
                        className="mb-3"
                        defaultValue={"DEFAULT"}
                      >
                        <option value="DEFAULT" disabled>
                          Select...
                        </option>

                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </Form.Select>
                    </div>
                    {formik.values.websitePp === "No" && (
                      <div className="popi-action">
                        <p>
                          1. Follow the{" "}
                          <a href="https://www.lacoona.legal/dashboard/legal-products/intro/13/Website%20Privacy%20Policy">
                            link
                          </a>{" "}
                          to complete a website privacy policy with your company
                          details.{" "}
                        </p>
                        <p>
                          2. The completed document will be sent to your email.
                        </p>
                        <p>3. Come back to your POPI Assessment to continue.</p>
                      </div>
                    )}
                  </div>
                ) : null}

                <div className="find-a-lawyer-form-question">
                  <p className="col-5 mx-3">
                    Do you have a copy of the government Guide to Promotion of
                    Access to Information Act (PAIA) in two languages?
                  </p>
                  <Form.Select
                    required
                    onChange={formik.handleChange}
                    name="paiaCopy"
                    aria-label="Default select example"
                    className="mb-3"
                    defaultValue={"DEFAULT"}
                  >
                    <option value="DEFAULT" disabled>
                      Select...
                    </option>

                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </Form.Select>
                </div>

                {formik.values.paiaCopy === "No" && (
                  <div className="popi-action">
                    <p>
                      1. Follow the link to the Information Regulator website to
                      access and download the government's{" "}
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href=" https://inforegulator.org.za/paia-guidelines/"
                      >
                        PAIA Guidelines
                      </a>{" "}
                    </p>
                    <p>
                      2. Choose two (2) language oprtions available on the site
                      and download them.
                    </p>
                    <p>
                      3. Make the PAIA Guidelines (in two languages) available
                      on your website or print them and keep hard copies
                      available at your business.
                    </p>
                    <p>4. Come back to your POPI Assessment to continue.</p>
                  </div>
                )}

                <div className="find-a-lawyer-form-question">
                  <p className="col-5 mx-3">
                    Do you have a Promotion of Access to Information Act (PAIA)
                    Manual for your company?
                  </p>
                  <Form.Select
                    required
                    onChange={formik.handleChange}
                    name="paiaManual"
                    aria-label="Default select example"
                    className="mb-3"
                    defaultValue={"DEFAULT"}
                  >
                    <option value="DEFAULT" disabled>
                      Select...
                    </option>

                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </Form.Select>
                </div>
                {formik.values.paiaManual === "No" && (
                  <div className="popi-action">
                    <p>
                      1. Follow the{" "}
                      <a href="https://www.lacoona.legal/dashboard/legal-products/intro/1/PAIA%20Manual%20Template">
                        link
                      </a>{" "}
                      to complete your company's PAIA Manual with your company
                      details.
                    </p>
                    <p>2. The completed document will be sent to your email.</p>
                    <p>3. Come back to your POPI Assessment to continue.</p>
                  </div>
                )}
              </Form>
              {/*    {showStats && 
              <div className = "results">
                <p>This is a summary of your form results</p>
                <p> {formik.values.infoOfficer}
                </p>
                
                
                </div>} */}

              <Row>
                <Col>
                  <button
                    className="lcn-button-orange py-2 px-4"
                    onClick={setPreviousFormStep}
                  >
                    Back
                  </button>
                </Col>
                <Col className="form-step-next-button-container">
                  <button
                    className="lcn-button-orange py-2 px-4"
                    onClick={formik.submitForm}
                    type="submit"
                  >
                    Submit
                  </button>
                </Col>
              </Row>
            </Col>
          )}
        </Row>

        {formStep === 3 && (
          <Col className="form-step" lg={12}>
            <Row>
              <h4 className="form-step-heading text-center">
                Thank you for your submission. You will receive your POPI
                assessment feedback in your mailbox.
              </h4>
            </Row>
          </Col>
        )}
      </Row>
    </Col>
  );
}

export default Popi;
